<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import DataTable from "@/components/DataTable.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Monthly Profits Analysis Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
  },
  data() {
    return {
      total_paid: 0,
      filterSales: {
        // month: this.currentdate.getMonth(),
        month: moment().month(),
        year: moment().year(),
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Monthly Profits Analysis Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Monthly Profits Analysis Report",
          active: true,
        },
      ],
      totalRows: 1,

      pageOptions: [10, 25, 50, 100, 200, 1000],
      IsMonthlyProfitsAnalysisServerPaginated: true,
      serverPerPage: 50,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      monthfields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "month",
          sortable: true,
          label: "MONTH",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "profit",
          sortable: true,
          label: "TOTAL PROFITS",
        },
        {
          key: "details",
          sortable: true,
          label: "DETAILS",
        },
      ],
      Months: [
        { id: 12, text: "All Months" },
        { id: 0, text: "January" },
        { id: 1, text: "February" },
        { id: 2, text: "March" },
        { id: 3, text: "April" },
        { id: 4, text: "May" },
        { id: 5, text: "June" },
        { id: 6, text: "July" },
        { id: 7, text: "August" },
        { id: 8, text: "September" },
        { id: 9, text: "October" },
        { id: 10, text: "November" },
        { id: 11, text: "December" },
      ],
      annual: {
        jansales: 0,
        febsales: 0,
        marchsales: 0,
        aprilsales: 0,
        maysales: 0,
        junesales: 0,
        julysales: 0,
        augsales: 0,
        sepsales: 0,
        octsales: 0,
        novsales: 0,
        decsales: 0,
        total: 0,
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("sales", [
      "filterStatus",
      "MonthlyProfitsAnalysis",
      "MonthlyProfitsAnalysisPagination",
      "MonthlyProfitsAnalysisPaginated",
      "MonthlyProfitsAnalysisSummary",
    ]),
    ...mapGetters("users", ["Users"]),
    ...mapGetters("auth", ["business", "branch"]),

    rows() {
      return this.IsMonthlyProfitsAnalysisServerPaginated
        ? this.MonthlyProfitsAnalysisPagination.total
        : this.MonthlyProfitsAnalysis
        ? this.MonthlyProfitsAnalysis.length
        : 0;
    },

     perPage: {
      get() {
        if (this.IsMonthlyProfitsAnalysisServerPaginated) {
          return (
            this.MonthlyProfitsAnalysisPagination.per_page ||
            this.filterSales.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsMonthlyProfitsAnalysisServerPaginated) {
          this.filterSales.per_page = value;
          this.filterSales.page = 1;
          this.FetchMonthlyProfitsAnalysis(this.filterSales);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.MonthlyProfitsAnalysisPaginated &&
          this.MonthlyProfitsAnalysisPagination
          ? this.MonthlyProfitsAnalysisPagination.current_page
          : 1;
      },
      set(value) {
        if (this.MonthlyProfitsAnalysisPaginated) {
          this.filterSales.page = value;
          this.handlePageChange(value);
        }
      },
    },

    totals() {
      return (
        this.MonthlyProfitsAnalysisSummary || {
          totalAmount: 0,
          totalBuying: 0,
          totalProfit: 0,
        }
      );
    },
  },

  methods: {
    ...mapActions({
      FetchMonthlyProfitsAnalysis: "sales/fetchMonthlyProfits",
    }),

    // COMMA SEPERATORS
     thousandSeperator(m) {
      if (m === "" || m === undefined || m === null) {
        return m;
      }
      const str = m.toString();
      const integerPart = str.split(".")[0];
      return integerPart
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    ProfitsAnalysisData() {
      this.FetchMonthlyProfitsAnalysis(this.filterSales);
    },

    handlePageChange(newPage) {
      if (this.IsMonthlyProfitsAnalysisServerPaginated) {
        this.filterSales.page = newPage;
        this.FetchMonthlyProfitsAnalysis(this.filterSales);
      }
    },
  },


  watch: {
    MonthlyProfitsAnalysis(newValue) {
      if (!Array.isArray(newValue)) return;

      if (this.filterSales.month == 12) {
        let total = 0;
        const annual = {
          jansales: 0,
          febsales: 0,
          marchsales: 0,
          aprilsales: 0,
          maysales: 0,
          junesales: 0,
          julysales: 0,
          augsales: 0,
          sepsales: 0,
          octsales: 0,
          novsales: 0,
          decsales: 0,
          total: 0,
        };
        newValue.forEach((item) => {
          const profit = item.profit || 0;
          total += profit;
          switch (item.salemonth) {
            case 1:
              annual.jansales += profit;
              break;
            case 2:
              annual.febsales += profit;
              break;
            case 3:
              annual.marchsales += profit;
              break;
            case 4:
              annual.aprilsales += profit;
              break;
            case 5:
              annual.maysales += profit;
              break;
            case 6:
              annual.junesales += profit;
              break;
            case 7:
              annual.julysales += profit;
              break;
            case 8:
              annual.augsales += profit;
              break;
            case 9:
              annual.sepsales += profit;
              break;
            case 10:
              annual.octsales += profit;
              break;
            case 11:
              annual.novsales += profit;
              break;
            case 12:
              annual.decsales += profit;
              break;
          }
        });
        annual.total = total;
        this.annual = annual;
      }
    },
  },

  created() {
    this.FetchMonthlyProfitsAnalysis(this.filterSales);
  },
};
</script>

<template>
  <Layout>
    <h4 class="text-center text-primary">{{ business }} - {{ branch }}</h4>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center">
                  Monthly Profits Analysis Report
                </h3>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 form-group">
                <label>MONTH</label>

                <model-list-select
                  :list="Months ? Months : []"
                  v-model="filterSales.month"
                  option-value="id"
                  option-text="text"
                  placeholder="Select Month"
                  @input="ProfitsAnalysisData()"
                >
                </model-list-select>
              </div>
              <div class="col-md-3 form-group">
                <label>YEAR</label>

                <input
                  v-model="filterSales.year"
                  placeholder="Enter Year"
                  class="form-control"
                />
              </div>
              <div class="col-md-2 mt-4">
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="ProfitsAnalysisData()"
                >
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="filterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
           
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0" v-if="filterSales.month != 12">
              <DataTable
                :columns="monthfields"
                :rows="MonthlyProfitsAnalysis || []"
                :total-rows="rows"
                :pagination="MonthlyProfitsAnalysisPagination"
                :server-pagination="IsMonthlyProfitsAnalysisServerPaginated"
                :loading="filterStatus"
              >
                <template #cell(index)="{ index }">
                  {{ (currentPage - 1) * perPage + index + 1 }}
                </template>
                <template #cell(month)="{ row }">
                  <p v-if="filterSales.month == 0">{{ "January" }}</p>
                  <p v-if="filterSales.month == 1">{{ "February" }}</p>
                  <p v-if="filterSales.month == 2">{{ "March" }}</p>
                  <p v-if="filterSales.month == 3">{{ "April" }}</p>
                  <p v-if="filterSales.month == 4">{{ "May" }}</p>
                  <p v-if="filterSales.month == 5">{{ "June" }}</p>
                  <p v-if="filterSales.month == 6">{{ "July" }}</p>
                  <p v-if="filterSales.month == 7">{{ "August" }}</p>
                  <p v-if="filterSales.month == 8">{{ "September" }}</p>
                  <p v-if="filterSales.month == 9">{{ "October" }}</p>
                  <p v-if="filterSales.month == 10">{{ "November" }}</p>
                  <p v-if="filterSales.month == 11">{{ "December" }}</p>
                </template>
                <template #cell(date)="{ row }">{{ row.date }}</template>
                <template #cell(profit)="{ row }">
                  {{ thousandSeperator(row.profit) }}
                </template>
                <template #cell(details)="{ row }">
                  <router-link
                    :to="{
                      name: 'Monthly Profits Details',
                      params: { date: row.date, period: filterSales.month },
                    }"
                  >
                    <b-button variant="info" class="btn btn-sm"
                      >Details</b-button
                    >
                  </router-link>
                </template>
              </DataTable>
              <div class="row">
                <div class="col-md-4">
                  <h5>
                    Total Buying:
                    <span class="text-danger">{{
                      thousandSeperator(totals.totalBuying)
                    }}</span>
                  </h5>
                </div>

                <div class="col-md-4">
                  <h5>
                    Total Profits:
                    <span class="text-danger">{{
                      thousandSeperator(totals.totalProfit)
                    }}</span>
                  </h5>
                </div>
               
                <div class="col-md-4">
                  <h5>
                    Total Amount:
                    <span class="text-danger">{{
                      thousandSeperator(totals.totalAmount)
                    }}</span>
                  </h5>
                </div>
              </div>
            </div>

            <div v-else>
              <table class="table-responsive mb-0 table" align="center">
                <thead>
                  <tr>
                    <th>MONTH</th>
                    <th>TOTAL PROFITS</th>
                    <th>DETAILS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="annual.jansales != 0">
                    <td>January</td>
                    <td>{{ thousandSeperator(annual.jansales) }}</td>
                    <td>
                      <router-link
                        :to="{
                          name: 'Monthly Profits Details',
                          params: { date: 1, period: filterSales.month },
                        }"
                      >
                        <b-button variant="info" class="btn btn-sm"
                          >Details</b-button
                        >
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="annual.febsales != 0">
                    <td>February</td>
                    <td>{{ thousandSeperator(annual.febsales) }}</td>
                    <td>
                      <router-link
                        :to="{
                          name: 'Monthly Profits Details',
                          params: { date: 2, period: filterSales.month },
                        }"
                      >
                        <b-button variant="info" class="btn btn-sm"
                          >Details</b-button
                        >
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="annual.marchsales != 0">
                    <td>March</td>
                    <td>{{ thousandSeperator(annual.marchsales) }}</td>
                    <td>
                      <router-link
                        :to="{
                          name: 'Monthly Profits Details',
                          params: { date: 3, period: filterSales.month },
                        }"
                      >
                        <b-button variant="info" class="btn btn-sm"
                          >Details</b-button
                        >
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="annual.aprilsales != 0">
                    <td>April</td>
                    <td>{{ thousandSeperator(annual.aprilsales) }}</td>
                    <td>
                      <router-link
                        :to="{
                          name: 'Monthly Profits Details',
                          params: { date: 4, period: filterSales.month },
                        }"
                      >
                        <b-button variant="info" class="btn btn-sm"
                          >Details</b-button
                        >
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="annual.maysales != 0">
                    <td>May</td>
                    <td>{{ thousandSeperator(annual.maysales) }}</td>
                    <td>
                      <router-link
                        :to="{
                          name: 'Monthly Profits Details',
                          params: { date: 5, period: filterSales.month },
                        }"
                      >
                        <b-button variant="info" class="btn btn-sm"
                          >Details</b-button
                        >
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="annual.junesales != 0">
                    <td>June</td>
                    <td>{{ thousandSeperator(annual.junesales) }}</td>
                    <td>
                      <router-link
                        :to="{
                          name: 'Monthly Profits Details',
                          params: { date: 6, period: filterSales.month },
                        }"
                      >
                        <b-button variant="info" class="btn btn-sm"
                          >Details</b-button
                        >
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="annual.julysales != 0">
                    <td>July</td>
                    <td>{{ thousandSeperator(annual.julysales) }}</td>
                    <td>
                      <router-link
                        :to="{
                          name: 'Monthly Profits Details',
                          params: { date: 7, period: filterSales.month },
                        }"
                      >
                        <b-button variant="info" class="btn btn-sm"
                          >Details</b-button
                        >
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="annual.augsales != 0">
                    <td>August</td>
                    <td>{{ thousandSeperator(annual.augsales) }}</td>
                    <td>
                      <router-link
                        :to="{
                          name: 'Monthly Profits Details',
                          params: { date: 8, period: filterSales.month },
                        }"
                      >
                        <b-button variant="info" class="btn btn-sm"
                          >Details</b-button
                        >
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="annual.sepsales != 0">
                    <td>September</td>
                    <td>{{ thousandSeperator(annual.sepsales) }}</td>
                    <td>
                      <router-link
                        :to="{
                          name: 'Monthly Profits Details',
                          params: { date: 9, period: filterSales.month },
                        }"
                      >
                        <b-button variant="info" class="btn btn-sm"
                          >Details</b-button
                        >
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="annual.octsales != 0">
                    <td>October</td>
                    <td>{{ thousandSeperator(annual.octsales) }}</td>
                    <td>
                      <router-link
                        :to="{
                          name: 'Monthly Profits Details',
                          params: { date: 10, period: filterSales.month },
                        }"
                      >
                        <b-button variant="info" class="btn btn-sm"
                          >Details</b-button
                        >
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="annual.novsales != 0">
                    <td>November</td>
                    <td>{{ thousandSeperator(annual.novsales) }}</td>
                    <td>
                      <router-link
                        :to="{
                          name: 'Monthly Profits Details',
                          params: { date: 11, period: filterSales.month },
                        }"
                      >
                        <b-button variant="info" class="btn btn-sm"
                          >Details</b-button
                        >
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="annual.decsales != 0">
                    <td>December</td>
                    <td>{{ thousandSeperator(annual.decsales) }}</td>
                    <td>
                      <router-link
                        :to="{
                          name: 'Monthly Profits Details',
                          params: { date: 12, period: filterSales.month },
                        }"
                      >
                        <b-button variant="info" class="btn btn-sm"
                          >Details</b-button
                        >
                      </router-link>
                    </td>
                  </tr>
                </tbody>
                <div class="row text-center">
                  <b
                    ><h5>
                      Grand Total: {{ thousandSeperator(annual.total) }}
                    </h5></b
                  >
                </div>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
